import MODULES from "../../../constants/modules";
import { routes } from "../../../constants/routes";
import { MenuItem } from "./menu-item";
import icons from "../../../assets/icons/icons";
import { useLogin } from "../../../common/hooks/useUser";

export interface SidebarProps {
  menuItems: MenuItem[];
  footerItems: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    label: "Dashboard",
    icon: icons.DashboardIcon,
    path: routes.DASHBOARD,
    classNames: "",
    navbarItem: false,
  },
  {
    label: "Lead Management",
    icon: icons.LeadIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.LEAD_MANAGEMENT,
    subMenu: [
      {
        label: "Lead Details",
        icon: icons.LeadDetails,
        path: routes.LEADLIST,
        moduleName: MODULES.LEAD_DETAILS,
        classNames: "",
      },
      {
        label: "Lead Capture",
        icon: icons.LeadCapture,
        path: routes.LEADCAPTUREFORM,
        classNames: "",
        moduleName: MODULES.LEAD_CAPTURE,
      },
      {
        label: "Lead Qualification",
        icon: icons.LeadQualification,
        path: routes.LEADQUALIFICATION,
        classNames: "",
        moduleName: MODULES.LEAD_QUALIFICATION,
      },
      {
        label: "Lead Assignment",
        icon: icons.LeadAssignment,
        path: "",
        classNames: "",
        moduleName: MODULES.LEAD_ASSIGNMENT,
        onlyShowTOAFP: true,
        subMenu: [
          {
            label: "Unassigned Leads",
            path: routes.UNASSIGNEDLEADS,
            classNames: "",
          },
          {
            label: "Assignment Rules",
            path: routes.ASSIGNMENTRULES,
            classNames: "",
          },
        ],
      },
      {
        label: "Assigned Leads",
        icon: icons.AssignedLeads,
        path: routes.ASSIGNEDLEADS,
        classNames: "",
        moduleName: MODULES.ASSIGNED_LEADS,
      },
      {
        label: "Lead Reports",
        icon: icons.LeadReports,
        path: routes.LEAD_REPORTS,
        classNames: "",
        moduleName: MODULES.LEAD_REPORTS,
      },
      {
        label: "Lead Logs",
        icon: icons.LeadLogs,
        path: routes.LEADLOGS,
        classNames: "",
        moduleName: MODULES.LEAD_LOGS,
      },
    ],
  },
  {
    label: "Customer Management",
    icon: icons.CustomerIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.CUSTOMER_MANAGEMENT,
    subMenu: [
      {
        label: "Customer Profile",
        icon: icons.Profile,
        path: routes.CUSTOMERLIST,
        classNames: "",
        moduleName: MODULES.CUSTOMER_PROFILE,
      },
      {
        label: "Customer Engagement",
        icon: icons.CustomerEngagement,
        path: routes.CUSTOMERENGAGEMENT,
        classNames: "",
        moduleName: MODULES.CUSTOMER_ENGAGEMENT,
      },
    ],
  },
  {
    label: "Campaigns",
    icon: icons.CampaignsIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.CAMPAIGNS,
    subMenu: [
      {
        label: "Create Campaigns",
        icon: icons.CreateCampaignIcon,
        path: routes.CREATECAMPAIGN,
        classNames: "",
        moduleName: MODULES.CREATE_CAMPAIGNS,
      },
      {
        label: "View Campaigns",
        icon: icons.ViewCampaignIcon,
        path: routes.CAMPAIGNLIST,
        classNames: "",
        moduleName: MODULES.VIEW_CAMPAIGNS,
      },
      {
        label: "Campaign Performance Metrics",
        icon: icons.MetricsCampaignIcon,
        path: routes.CAMPAIGN_PERFORMANCE_METRICS,
        classNames: "",
        moduleName: MODULES.CAMPAIGN_PERFORMANCE_METRICS,
      },
      {
        label: "Landing Page",
        icon: icons.LandingPageIcon,
        path: routes.LANDINGPAGE,
        classNames: "",
        moduleName: MODULES.LANDING_PAGE,
      },
      {
        label: "HubSpot",
        icon: icons.HubspotMenuIcon,
        path: routes.HUBSPOT,
        classNames: "",
        // moduleName: MODULES.HUBSPOT,
      }
    ],
  },
  {
    label: "Templates & QRs",
    icon: icons.SurveysIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.TEMPLATES_AND_QRS,
    subMenu: [
      {
        label: "Email Templates",
        icon: icons.EmailTemplateIcon,
        path: routes.EMAILTEMPLATES,
        classNames: "",
        moduleName: MODULES.EMAIL_TEMPLATES,
      },
      {
        label: "Letter Templates",
        icon: icons.LetterTemplateIcon,
        path: routes.LETTERTEMPLATES,
        classNames: "",
        moduleName: MODULES.LETTER_TEMPLATES,
      },
      {
        label: "Create Surveys",
        icon: icons.CreateCampaignIcon,
        path: routes.CREATESURVEY,
        classNames: "",
        moduleName: MODULES.CREATE_SURVEYS,
      },
      {
        label: "View Surveys",
        icon: icons.ViewCampaignIcon,
        path: routes.VIEWSURVEY,
        classNames: "",
        moduleName: MODULES.VIEW_SURVEYS,
      },
      {
        label: "QR Codes List",
        icon: icons.QrCodeIcon,
        path: routes.QRCODELIST,
        classNames: "",
        moduleName: MODULES.QR_CODE_LIST,
      },
      // {
      //   label: "Unsubscribed Users",
      //   icon: icons.ViewCampaignIcon,
      //   path: routes.UNSUBSCRIBED_USERS,
      //   classNames: "",
      //   moduleName: MODULES.UNSUBSCRIBED_USERS,
      // }
      {
        label: "General Notes",
        icon: icons.notesListIcon,
        path: routes.GENERAL_NOTES,
        classNames: "",
        moduleName: MODULES.GENERAL_NOTES,
      },
    ],
  },
  {
    label: "Payments",
    icon: icons.PaymentsIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.PAYMENTS,
    subMenu: [
      {
        label: "Order Management",
        icon: icons.OrderIcon,
        path: "",
        classNames: "",
        moduleName: MODULES.ORDER_MANAGEMENT,
        subMenu: [
          {
            label: "Orders",
            path: routes.ORDERSLIST,
            classNames: "",
          },
          {
            label: "Invoices",
            path: routes.INVOICELIST,
            classNames: "",
          },
          // {
          //   label: "Company Settings",
          //   path: "",
          //   classNames: "",
          // },
        ],
      },
      {
        label: "Subscription Reports",
        icon: icons.SubscriptionReportIcons,
        path: routes.SUBSCRIPTIONREPORT,
        classNames: "",
        moduleName: MODULES.SUBSCRIPTION_REPORT,
      },
      // {
      //   label: "Payments",
      //   icon: icons.PaymentIcon,
      //   path: "",
      //   classNames: "",
      //   moduleName: MODULES.PAYMENTS,
      // },
    ],
  },
  // {
  //   label: "Usage Metrics / Utilization ",
  //   icon: icons.StatisticsIcon,
  //   path: "",
  //   classNames: "",
  //   moduleName: MODULES.USAGE_METRICS,
  // },

  {
    label: "Partner Management",
    icon: icons.PartnerIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.TENANT_MANAGEMENT,
    subMenu: [
      {
        label: "Requests",
        icon: icons.RequestsIcon,
        path: routes.REQUESTS,
        classNames: "",
        moduleName: MODULES.PARTNER_REQUESTS,
      },
      {
        label: "Partner List",
        icon: icons.PartnerListIcon,
        path: routes.PARTNERLIST,
        classNames: "",
        moduleName: MODULES.PARTNER_LIST,
      },
      {
        label: "CRM Plans",
        icon: icons.CrmPlansIcon,
        path: "",
        classNames: "",
        moduleName: MODULES.PARTNER_CRM_PLANS,
        subMenu: [
          {
            label: "Create New Plans",
            path: routes.CREATE_CRM_PLAN,
            classNames: "",
          },
          {
            label: "Paid Plans",
            path: routes.CRM_PAID_PLANS,
            classNames: "",
          },
          {
            label: "No Cost Plans",
            path: routes.CRM_NO_COST_PLAN,
            classNames: "",
          },
          {
            label: "Trial Plans",
            path: routes.CRM_TRIAL_PLANS,
            classNames: "",
          },
          {
            label: "Custom Plans",
            path: routes.CRM_CUSTOM_PLANS,
            classNames: "",
          },
        ],
      },
    ],
  },
  {
    label: "User Management",
    icon: icons.UserIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.USER_MANAGEMENT,
    subMenu: [
      {
        label: "User Requests",
        icon: icons.RequestsIcon,
        path: routes.USER_REQUESTS,
        classNames: "",
        moduleName: MODULES.USER_REQUESTS,
      },
      {
        label: "User List",
        icon: icons.PartnerListIcon,
        path: routes.USER_MANAGEMENT_LIST,
        classNames: "",
        moduleName: MODULES.USER_LISTS,
      },
      {
        label: "User Roles & Permissions",
        icon: icons.RoleSettingsIcon,
        path: routes.USER_MANAGEMENT_ROLE,
        classNames: "",
        moduleName: MODULES.USER_ROLES_AND_PERMISSIONS,
      },
      {
        label: "User Reports",
        icon: icons.LeadReports,
        path: routes.USER_REPORTS,
        classNames: "",
        moduleName: MODULES.USER_REPORTS,
      },
      {
        label: "Update Terms of Services",
        icon: icons.infoIcon,
        path: routes.USER_MANAGEMENT_TERMSOFSERVICES,
        classNames: "",
      },
    ],
  },
];

const tenantDetails = localStorage.getItem("loginData");
const tenantParsed = tenantDetails ? JSON.parse(tenantDetails) : {};

export const footerItems: MenuItem[] = [
  {
    label: "Tickets",
    icon: icons.CustomerSupport,
    path: routes.SUPPORT_TICKETS,
    classNames: "",
    moduleName: MODULES.SUPPORT_TICKETS,
  },
  {
    label: "Support",
    icon: icons.CustomerSupport,
    path: routes.CUSTOMERSUPPORT,
    classNames: "",
    moduleName: MODULES.CUSTOMER_SUPPORT,
  },
  // {
  //   label: "Notifications",
  //   icon: icons.notificationIcon,
  //   path: "",
  //   classNames: "",
  // },
  {
    label: "Settings",
    icon: icons.settingsIcon,
    path: "",
    classNames: "",
    moduleName: MODULES.SETTINGS,
    subMenu: [
      {
        label: "General Settings",
        icon: icons.RoleSettingsIcon,
        path: "",
        classNames: "",
        subMenu: [
          {
            label: "Personal Settings",
            path: routes.PERSONAL_SETTINGS,
            classNames: "",
          },
          {
            label: "Company Settings",
            path: routes.COMPANYSETTINGS,
            classNames: "",
          },
          {
            label: "My Plans",
            path: routes.MY_PLANS,
            classNames: "",
            permissionRole: [1, 2],
          },
        ],
      },
      {
        label: "Track Uploads",
        icon: icons.TrackUploadsIcon,
        path: routes.TRACK_UPLOADS,
        classNames: "",
        moduleName: MODULES.TRACK_UPLOADS,
      },
      {
        label: "AI Call Monitoring",
        icon: icons.AICallMonitoringIcon,
        path: routes.AI_CALL_MONITORING,
        classNames: "",
        // moduleName: MODULES.AI_CALL_MONITORING,
      },
    ],
  },
  {
    label: "Guides",
    icon: icons.guidesIcon,
    path: routes.GUIDES,
    classNames: "",
    // moduleName: MODULES.GUIDES,
  },
  {
    label: "Terms of Services",
    icon: icons.infoIcon,
    path: routes.TERMSOFSERVICES,
    classNames: "",
  },
  {
    label: "Logout",
    icon: icons.logoutIcon,
    path: "#",
    classNames: "",
  },
];
